var num = require('num')
var constants = require('./constants')
var numbers = require('./numbers')
var moment = require('moment')

exports.formatAmount = function(amount) {
  if (typeof amount == 'string') {
    return exports.formatDrops(amount)
  }

  return numbers.format(amount.value, { currency: amount.currency + ':' + amount.issuer.substr(0, 4) })
}

exports.formatDrops = function(n) {
  return numbers.format(num(n, 6), { currency: constants.nativeCurrency })
}

exports.networkEpochToDate = function(epoch) {
  return new Date((constants.epoch + epoch) * 1e3)
}

exports.date = function(date) {
  return moment(date).format('YYYY-MM-DD HH:mm:ss')
}

exports.isTransactionHash = function(value) {
  return !!value.match(/^[a-zA-Z0-9]{64}$/)
}

exports.isRippleAccountId = function(value) {
  return !!value.match(/^1[a-zA-Z0-9]{31,33}$/)
}

exports.formatRemoteResponseError = function(err) {
  return (err.remote && err.remote.error_message) || err.error_message || err.message || err.toString()
}

exports.hex_to_ascii = function(str1) {
    var hex  = str1.toString();
    var str = '';
    for (var n = 0; n < hex.length; n += 2) {
        str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
    }
    return str;
}

exports.escapeHtml = function(unsafe) {
    return unsafe
         .replace(/&/g, "&amp;")
         .replace(/</g, "&lt;")
         .replace(/>/g, "&gt;")
         .replace(/"/g, "&quot;")
         .replace(/'/g, "&#039;");
}



//////////////////
// WEBPACK FOOTER
// ./src/helpers/formatters.js
// module id = 221
// module chunks = 0